import {
  title,
  blackColor,
  grayColor,
  hexToRgb
} from "@app/assets/jss/material-kit-pro-react";

const messageStyle = {
  messageText: {
    display: "block",
    textAlign: "center",
    fontSize: "150%"
  }
};

export default messageStyle;
